import React, { useState } from 'react';
import { InView } from 'react-intersection-observer';
import MobileDevPageVideoBtf from '@wix/da-ads/pkg/adunits/anon/MobileDevPageVideoBtf';
import MobileDevPageStage320x100 from '@wix/da-ads/pkg/adunits/anon/MobileDevPageStage320x100';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import { useShowMobileAd } from '../../ArtStage/hooks/useShowMobileAd';
import LoadingIndicator from '../../LoadingIndicator';
import ArtStage from '../../ArtStage';
import MonetizationStrip from '../../MonetizationStrip';
import ActionBar from '../../ActionBar';
import Sidebar from '../../Sidebar';
import Details from '../../DeviationViews/Details';
import SubPaywall from '../../DeviationViews/Full/_partials/SubPaywall';
import PanelPopup from '../../DeviationPage/_partials/PanelPopup';
import { DeviationTypes } from '../../types/deviation';
import { getCommentableTypeForDeviationType, isExtendedDeviationFullyLoaded } from '../redux/helpers';
import Comments from '../_partials/Comments';
import TierUpsell from '../_partials/TierUpsell';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import LiteratureTextualContent from '../../DeviationViews/TextualContent/Literature';
import MobileAdhesion from '@wix/da-ads/pkg/adunits/anon/MobileAdhesion';
import UserMobileAdhesion from '@wix/da-ads/pkg/adunits/user/MobileAdhesion';
import AnonOrUserUnit from '@wix/da-ads/pkg/adunits/AnonOrUserUnit';
import ErrorBoundary from '../../ErrorBoundary';
import { useSelector } from 'react-redux';
import { getCurrentAdSafety } from '../../Ads/redux/selectors';
import MonetizationBlock from '../../Sidebar/SidebarBlock/layouts/MonetizationBlock';
import withHydrationOnDemand from 'react-hydration-on-demand';
const CommentsWithHydrationOnDemand = withHydrationOnDemand({
    on: [
        'visible'
    ]
})(Comments);
import s from './MobileDeviationPage.scss';
const MobileDeviationPage = ({ deviation  })=>{
    var _deviation_extended, _deviation_extended_relatedContent, _deviation_extended1;
    const isMobilePerfTest = useFlag('mobile_perf');
    const isPromoHigherMobileFlagEnabled = useFlag('promo_higher_mobile');
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const deviationType = getDeviationType(deviation);
    const isJournal = deviationType === DeviationTypes.JOURNAL;
    const isLiterature = deviationType === DeviationTypes.LITERATURE;
    const isJournalOrLit = isJournal || isLiterature;
    const { typeId , deviationId  } = deviation;
    const commentableTypeId = getCommentableTypeForDeviationType(typeId);
    const { tier , isSubscribedButBlocked , needsSubscription  } = useSubscriptionTier(deviation);
    const isBlocked = needsSubscription || isSubscribedButBlocked;
    const { showVideoBtfAd , showAtfAd , showAdhesionAd  } = useShowMobileAd(deviation);
    const adSafety = useSelector((state)=>getCurrentAdSafety(state));
    const isNsfgFallback = useFlag('ads_dealer_nsfg');
    // we'll force a re-render of the page when a countdown in the offer banner of the monetization strip
    // reaches 0 (onAdoptableSaleEnd). This will update the actionbar to change from the 'make an offer'
    // button to the 'view offers' button to show the sale is over
    const [hasAdoptionEnded, setHasAdoptionEnded] = useState(false);
    const monetizationBlock = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_relatedContent = _deviation_extended.relatedContent) === null || _deviation_extended_relatedContent === void 0 ? void 0 : _deviation_extended_relatedContent.find((block)=>block.contentType.includes('monetization_') || block.contentType === 'monetization_promotion_adoptable');
    return /*#__PURE__*/ React.createElement(React.Fragment, null, showAdhesionAd && /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "MobileAdhesion"
    }, /*#__PURE__*/ React.createElement(AnonOrUserUnit, {
        anon: MobileAdhesion,
        user: UserMobileAdhesion,
        safety: adSafety
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, showAtfAd && (adSafety !== 'off' || isNsfgFallback) && /*#__PURE__*/ React.createElement("div", {
        className: s['ad-wrapper-static-atf']
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "MobileDevPageStage320x100"
    }, /*#__PURE__*/ React.createElement(MobileDevPageStage320x100, {
        safety: adSafety
    }))), /*#__PURE__*/ React.createElement(ArtStage, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(MonetizationStrip, {
        className: s['strip-tier-promotion'],
        deviation: deviation,
        onAdoptableSaleEnd: ()=>setHasAdoptionEnded(true)
    }), /*#__PURE__*/ React.createElement(ActionBar, {
        // maintain a key so we can force a re-render
        key: `actionbar-${hasAdoptionEnded}`,
        deviation: deviation
    }), isLiterature && /*#__PURE__*/ React.createElement("div", {
        className: s['lit-content']
    }, /*#__PURE__*/ React.createElement(LiteratureTextualContent, {
        deviation: deviation
    })), /*#__PURE__*/ React.createElement(PanelPopup, {
        deviation: deviation,
        actionBarType: "primary",
        className: s['large-popover-uplifted']
    }), /*#__PURE__*/ React.createElement(Details, {
        contentClassName: s['details'],
        deviation: deviation
    }), showVideoBtfAd && (adSafety !== 'off' || isNsfgFallback) && /*#__PURE__*/ React.createElement("div", {
        className: s['ad-wrapper']
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "MobileDevPageVideoStage"
    }, /*#__PURE__*/ React.createElement(InView, {
        triggerOnce: true,
        threshold: 0.1
    }, ({ inView , ref  })=>/*#__PURE__*/ React.createElement("div", {
            ref: ref
        }, inView && /*#__PURE__*/ React.createElement(MobileDevPageVideoBtf, {
            safety: adSafety
        }))))), /*#__PURE__*/ React.createElement(UserGiftSaleBanner, {
        user: deviation.author
    }), isJournalOrLit && isBlocked && /*#__PURE__*/ React.createElement(SubPaywall, {
        deviation: deviation,
        showImage: false
    }), isExtendedLoaded ? /*#__PURE__*/ React.createElement(React.Fragment, null, isPromoHigherMobileFlagEnabled && ((_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : _deviation_extended1.showStageMonetizationPromo) && monetizationBlock && /*#__PURE__*/ React.createElement(MonetizationBlock, {
        block: monetizationBlock,
        deviation: deviation
    }), !isBlocked && (isMobilePerfTest ? /*#__PURE__*/ React.createElement(CommentsWithHydrationOnDemand, {
        key: `${commentableTypeId}:${deviationId}`,
        deviation: deviation,
        className: s['comments']
    }) : /*#__PURE__*/ React.createElement(Comments, {
        key: `${commentableTypeId}:${deviationId}`,
        deviation: deviation,
        className: s['comments']
    })), !isBlocked && !!tier && /*#__PURE__*/ React.createElement(TierUpsell, {
        className: s['upsell'],
        deviation: deviation
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['sidebar']
    }, /*#__PURE__*/ React.createElement(Sidebar, {
        deviation: deviation
    }))) : /*#__PURE__*/ React.createElement(LoadingIndicator, {
        className: s['lloader'],
        view: "llama"
    }), isBlocked && !!tier && /*#__PURE__*/ React.createElement(TierUpsell, {
        className: s['upsell'],
        deviation: deviation
    })));
};
MobileDeviationPage.displayName = 'MobileDeviationPage';
export default MobileDeviationPage;
